export default "/_next/static/images/kimberly-hollinger-d81c4e9c133224ec79bf63ead17d2cdb.png";